/**
 * Shared file download utilities
 */
export const XLSX_MIME = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
export const PDF_MIME = 'application/pdf';

function triggerDownload(blob: Blob | ArrayBuffer, filename: string, mimeType: string): void {
  const downloadBlob = new Blob([blob], { type: mimeType });
  const url = URL.createObjectURL(downloadBlob);
  const link = document.createElement('a');
  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

export function downloadExcelFile(blob: Blob | ArrayBuffer, filename: string): void {
  triggerDownload(blob, filename, XLSX_MIME);
}

export function downloadPdfFile(blob: Blob | ArrayBuffer, filename: string): void {
  triggerDownload(blob, filename, PDF_MIME);
}
